import axios from '../jslib/http'
const BASE_REQUEST = '/tms/stowage'
import qs from 'qs'
import {request} from "../jslib/request";


export function checkStowage(
    id
) {
    return request({
        url:`${BASE_REQUEST}/checkStowage`,
        data:{
            id:id
        }
    })
}

export function yupeizaiFinal(
    shiplineid
) {
    return request({
        url:`${BASE_REQUEST}/yupeizaiFinal`,
        data:{
            shiplineid:shiplineid
        }
    })
}

export function yupeizaiStart(
  shiplineid
) {
  return request({
    url:`${BASE_REQUEST}/yupeizaiStart`,
    data:{
      shiplineid:shiplineid
    }
  })
}
export function tijiaocaiwu(
  shiplineid
) {
  return request({
    url:`${BASE_REQUEST}/tijiaocaiwu`,
    data:{
      shiplineid:shiplineid
    }
  })
}

export function getStowageDetil(
    shiplineid,
    isTaxIncluded
) {
    return request({
        url:`${BASE_REQUEST}/getStowageDetil`,
        data:{
            shiplineid:shiplineid,
            isTaxIncluded:isTaxIncluded
        }
    })
}
export function getUUid(
) {
  return request({
    url:`${BASE_REQUEST}/getUUid`,
    data:{
    }
  })
}

export function getShipLineFlows(
    shiplineid
) {
    return request({
        url:`${BASE_REQUEST}/getShipLineFlows`,
        data:{
            shiplineid:shiplineid
        }
    })
}

export function saveFlowTo(
    shiplineId,flowId
) {
    return request({
        url:`${BASE_REQUEST}/saveFlowTo`,
        data:{
            shiplineId:shiplineId,
            flowId:flowId
        }
    })
}
export function getAllFlowTo(
    shiplineid
) {
    return request({
        url:`${BASE_REQUEST}/getAllFlowTo`,
        data:{
            shiplineid:shiplineid
        }
    })
}

export function updateStowage (stowageid,goodsIds) {
    const url = `${BASE_REQUEST}/updateStowage`
    const data = {
        stowageid:stowageid,
        goodsIds:goodsIds
    }
    return axios
        .get(url, {
            params: data
        })
        .then(res => {
            if (res !== undefined) {
                return Promise.resolve(res.data)
            } else {
                return Promise.resolve(res)
            }
        })
}
export function addStowage (shiplineid,shipdataId,goodsIds,isfenchuans) {
    const url = `${BASE_REQUEST}/addStowage`
    const data = {
        shiplineid:shiplineid,
        shipdataId:shipdataId,
        goodsIds:goodsIds,
        isfenchuans:isfenchuans
    }
    return axios
        .get(url, {
            params: data
        })
        .then(res => {
            if (res !== undefined) {
                return Promise.resolve(res.data)
            } else {
                return Promise.resolve(res)
            }
        })
}

export function getStowage (lineid,type) {
    const url = `${BASE_REQUEST}/getStowage`
    const data = {
        lineid:lineid,
        type:type
    }
    return axios
        .get(url, {
            params: data
        })
        .then(res => {
            if (res !== undefined) {
                return Promise.resolve(res.data)
            } else {
                return Promise.resolve(res)
            }
        })
}

export function delStowage (stowageId) {
    const url = `${BASE_REQUEST}/delStowage`
    const data = {
        stowageId:stowageId
    }
    return axios
        .get(url, {
            params: data
        })
        .then(res => {
            if (res !== undefined) {
                return Promise.resolve(res.data)
            } else {
                return Promise.resolve(res)
            }
        })
}

export function getShipLine (stowageId) {
    const url = `${BASE_REQUEST}/getshipLineByStowageId`
    const data = {
        stowageId:stowageId
    }
    return axios
        .get(url, {
            params: data
        })
        .then(res => {
            if (res !== undefined) {
                return Promise.resolve(res.data)
            } else {
                return Promise.resolve(res)
            }
        })
}
export function getStowageByPage (pageNo,pageSize,lineid,type,startTime,endTime,shipName) {
    const url = `${BASE_REQUEST}/getStowageByPage`
    const data = {
        pageNo: pageNo,
        pageSize: pageSize,
        lineid:lineid,
        type:type,
        startTime:startTime,
        endTime:endTime,
        shipName:shipName
    }
    return axios
        .get(url, {
            params: data
        })
        .then(res => {
            if (res !== undefined) {
                return Promise.resolve(res.data)
            } else {
                return Promise.resolve(res)
            }
        })
}

export function saveStowage (
    obj
) {
    const url = `${BASE_REQUEST}/saveStowage`
    const data = obj
    return axios
        .post(url, qs.stringify(data))
        .then(res => {
            if (res !== undefined) {
                return Promise.resolve(res.data)
            } else {
                return Promise.resolve(res)
            }
        })
}

export function updateStowageInfo (
    obj
) {
    const url = `${BASE_REQUEST}/updateStowageInfo`
    const data = obj
    return axios
        .post(url, qs.stringify(data))
        .then(res => {
            if (res !== undefined) {
                return Promise.resolve(res.data)
            } else {
                return Promise.resolve(res)
            }
        })
}

export function getStowageById (stowageId,qName) {
    const url = `${BASE_REQUEST}/getStowageById`
    const data = {
        stowageId:stowageId,
        qName:qName
    }
    return axios
        .get(url, {
            params: data
        })
        .then(res => {
            if (res !== undefined) {
                return Promise.resolve(res.data)
            } else {
                return Promise.resolve(res)
            }
        })
}

export function addCustomergoods (stowageId,goodsIds,isfenchuans) {
    const url = `${BASE_REQUEST}/addCustomergoods`
    const data = {
        stowageId:stowageId,
        goodsIds:goodsIds,
        isfenchuans:isfenchuans
    }
    return axios
        .get(url, {
            params: data
        })
        .then(res => {
            if (res !== undefined) {
                return Promise.resolve(res.data)
            } else {
                return Promise.resolve(res)
            }
        })
}
export function delCustomerGoods (stowageId,goodsId) {
    const url = `${BASE_REQUEST}/delCustomerGoods`
    const data = {
        stowageId:stowageId,
        goodsId:goodsId,
    }
    return axios
        .get(url, {
            params: data
        })
        .then(res => {
            if (res !== undefined) {
                return Promise.resolve(res.data)
            } else {
                return Promise.resolve(res)
            }
        })
}
export function getAllCustomerGoods (stowageId) {
    const url = `${BASE_REQUEST}/getAllCustomerGoods`
    const data = {
        stowageId:stowageId,
    }
    return axios
        .get(url, {
            params: data
        })
        .then(res => {
            if (res !== undefined) {
                return Promise.resolve(res.data)
            } else {
                return Promise.resolve(res)
            }
        })
}

export function getAutoMatchGoodsList(querydata) {
    return request({
        url:`${BASE_REQUEST}/goodsAutoMatch`,
        data:querydata
    })
}

export function stowagedetail (Id) {
    const url = `${BASE_REQUEST}/stowagedetail`
    const data = {
        Id:Id,
    }
    return axios
        .get(url, {
            params: data
        })
        .then(res => {
            if (res !== undefined) {
                return Promise.resolve(res.data)
            } else {
                return Promise.resolve(res)
            }
        })
}


export function removeStowage(
  shiplineId
) {
  return request({
    url:`${BASE_REQUEST}/removeStowage`,
    data:{
      shipLineId:shiplineId
    }
  })
}

export function getStowageMoneyById(
  shipLineId,
  userid
) {
  return request({
    url:`${BASE_REQUEST}/getStowageMoneyById`,
    data:{
      shipLineId:shipLineId,
      userid:userid
    }
  })
}
export function getStowageHistoryById(
  shipLineId
) {
  return request({
    url:`${BASE_REQUEST}/getStowageHistoryById`,
    data:{
      shipLineId:shipLineId
    }
  })
}
export function getshouye(
) {
  return request({
    url:`${BASE_REQUEST}/getshouye`,
  })
}

export function getYewuStowage(startTime,shipName
) {
  return request({
    url:`${BASE_REQUEST}/getYewuStowage`,
    data:{
      startTime:startTime,
      shipName:shipName,
    }
  })
}
export function getEarlierYewuStowage(startTime,endTime,shipName
) {
  return request({
    url:`${BASE_REQUEST}/getEarlierYewuStowage`,
    data:{
      startTime:startTime,
      endTime:endTime,
      shipName:shipName,
    }
  })
}
export function deleteshiplineyewu(
  list
) {
  return request({
    url:`${BASE_REQUEST}/deleteshiplineyewu`,
    data:{
      list:list
    }
  })
}
export function checkguazhang( id
) {
  return request({
    url:`${BASE_REQUEST}/checkguazhang`,
    data:{
      id:id
    }
  })
}
export function getSpListByShipLineId( shipLineId
  ) {
    return request({
      url: `${BASE_REQUEST}/getSpListByShipLineId`,
      method:'get',
      data:{
        shipLineId:shipLineId
      }
    })
  }
